import CardDiv from "modules/common/card-div/CardDiv";
import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import BuildPlan from "./BuildPlan";
import CsatFeedback from "./CsatFeedback";
import TicketFeedbackData from "./TicketFeedbackData";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";



function FeedbackHeader({ applyDate, setTable, table, buildPlan, csatFeedback,feedbackData,planLength,csatLength,feedBackLength }) {
  const navigate= useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sd=searchParams.get("sd");
  const ed=searchParams.get("ed");
  const [date, setDate] = useState(null);
  return (
    <div className="d-flex justify-content-between gap-3 ">
      <div
        className={`flex-1 cursor-pointer rounded ${
          table === "customer" && `custom-lg-shadow`
        }`}
        onClick={() => {
          setTable("customer");
          navigate(`/customer-feedback?tab=customer&pageNumber=1&sd=${sd}&ed=${ed}`)
        }}
      >
        <CardDiv
          title={
            <span
              className={`${table === "customer" && `fw-bold text-primary`}`}
            >
              Build a plan
            </span>
          }
          component={
            <BuildPlan data={buildPlan} planLength={planLength} />
        }
        />
      </div>
      <div
        className={`flex-1 cursor-pointer rounded ${
          table === "csat" && `custom-lg-shadow`
        }`}
        onClick={() => {
          setTable("csat");
          navigate(`/customer-feedback?tab=csat&pageNumber=1&sd=${sd}&ed=${ed}`)

        }}
      >
        <CardDiv
          title={
            <span className={`${table === "csat" && `fw-bold text-primary`}`}>
              CSAT Feedback
            </span>
          }
          component={<div>
             <CsatFeedback data={csatFeedback} csatLength={csatLength}  />
          </div>}
        />
      </div>
      <div
        className={`flex-1 cursor-pointer rounded ${
          table === "ticket" && `custom-lg-shadow`
        }`}
        onClick={() => {
          setTable("ticket");
          navigate(`/customer-feedback?tab=ticket&pageNumber=1&sd=${sd}&ed=${ed}`)
        }}
      >
        <CardDiv
          title={
            <span className={`${table === "ticket" && `fw-bold text-primary`}`}>
              Ticket Feedback
            </span>
          }
          component={<div> <TicketFeedbackData data={feedbackData} feedbackLength={feedBackLength} /> </div>}
        />
      </div>
      <div
        className="flex-1"

      >
        <CardDiv
          title={"Select Date"}
          component={
            <div >
              <ReactDatePicker
                selected={date}
                onChange={(date) => {
                  setDate(date);
                  applyDate(date);
                }}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </div>
          }
        />
      </div>
    </div>
  );
}

export default FeedbackHeader;